import { RecommendationItem } from "../../calcBusterTypes";
import { Box, Badge } from "@amzn/awsui-components-react";
import { USDollar } from "../../util";

export const COLUMN_DEFINITIONS = [
  {
    id: "id",
    header: "Rule ID",
    cell: (item: RecommendationItem) => item.id,
    sortingField: "id",
  },
  {
    id: "severity",
    header: "Severity",
    cell: (item: RecommendationItem) => item.severity,
    sortingField: "severity",
  },
  {
    id: "service",
    header: "Service",
    cell: (item: RecommendationItem) => item.service,
    sortingField: "service",
  },
  {
    id: "instances",
    header: "Instances",
    cell: (item: RecommendationItem) => item.instancesCount,
    sortingField: "instancesCount",
  },
  {
    id: "recommendation",
    header: "Recommendation",
    cell: (item: RecommendationItem) => (
      <div>
        <Box display={"block"}>{item.description}.</Box>
        <Box display={"block"}>{item.recommendation}</Box>
      </div>
    ),
    sortingField: "recommendation",
  },
  {
    id: "tags",
    header: "Tags",
    cell: (item: RecommendationItem) => (
      <div>
        {" "}
        {item.tags.map((t) => (
          <Box display={"block"}>
            {" "}
            <Badge color="blue">{t}</Badge>{" "}
          </Box>
        ))}{" "}
      </div>
    ),
    sortingField: "savings",
  },
  {
    id: "savings",
    header: "Savings",
    cell: (item: RecommendationItem) => USDollar.format(item.savings),
    sortingField: "savings",
  },
];

export function EmptyState({
  title,
  subtitle,
  action,
}: {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
}) {
  return (
    <Box textAlign="center" color="inherit">
      <Box variant="strong" textAlign="center" color="inherit">
        {title}
      </Box>
      <Box variant="p" padding={{ bottom: "s" }} color="inherit">
        {subtitle}
      </Box>
      {action}
    </Box>
  );
}

export function getMatchesCountText(count: number) {
  return count === 1 ? `1 match` : `${count} matches`;
}

const pageSizePreference = {
  title: "Select page size",
  options: [
    { value: 10, label: "10 resources" },
    { value: 20, label: "20 resources" },
  ],
};

const visibleContentPreference = {
  title: "Select visible content",
  options: [
    {
      label: "Main properties",
      options: COLUMN_DEFINITIONS.map(({ id, header }) => ({
        id,
        label: header,
        editable: id !== "id",
      })),
    },
  ],
};

export const collectionPreferencesProps = {
  pageSizePreference,
  visibleContentPreference,
  cancelLabel: "Cancel",
  confirmLabel: "Confirm",
  title: "Preferences",
};

interface ColumnDisplayProperty {
  id: string;
  visible: boolean;
}

export function convertToColumnProps(visibleIds: string[], allIds: string[]) {
  const columnProps = [];
  for (const id of allIds) {
    if (visibleIds.includes(id)) {
      columnProps.push({ id: id, visible: true });
    } else {
      columnProps.push({ id: id, visible: false });
    }
  }
  return columnProps as readonly ColumnDisplayProperty[];
}
